// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/valori-ammessi?societaId=N',
    requestBody: null,
    response: '{"success":true,"data":"ValoriAmmessi"}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?ruolo=FORNITORE&limit=200&societaId=N',
    requestBody: null,
    response: '{"data":"Nominativo[]","total":0}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini/utenti?societaId=N',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini',
    requestBody: null,
    response: '{"success":true,"data":"ImportListino[]","total":"number","page":"number","limit":"number"}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini/template',
    requestBody: null,
    response: 'file xlsx'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/listini/upload',
    requestBody: '(multipart: file, societaId, fornitoreId, etichetta, note, strategiaAggiornamento)',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini/:id/file-log',
    requestBody: null,
    response: 'file stream (attachment)'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
